import { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { Modal } from './ui/modal';
import { Button } from './ui/button';
import { archiveTenant, getApiError } from '../services/api';

interface Props {
  tenant?: { id: number; name: string };
  onClose: () => void;
  onArchived: (name: string) => void;
}

export const ArchiveTenantDialog = ({ tenant, onClose, onArchived }: Props) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const archive = async () => {
    if (!tenant) return;
    setSaving(true);
    setError('');
    try {
      await archiveTenant(tenant.id);
      onArchived(tenant.name);
    } catch (requestError) {
      setError(getApiError(requestError));
      setSaving(false);
    }
  };

  return (
    <Modal open={Boolean(tenant)} onClose={saving ? () => {} : onClose} title="Архивировать организацию?" maxWidth="max-w-sm"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={saving}>Отмена</Button>
          <Button variant="destructive" onClick={archive} disabled={saving}>
            {saving ? <span className="h-4 w-4 animate-spin rounded-full border-2 border-destructive-foreground border-t-transparent" /> : <Trash2 className="h-4 w-4" />}
            Архивировать
          </Button>
        </>
      }
    >
      {error && <div className="mb-4 rounded-lg border border-destructive/20 bg-destructive/10 px-4 py-3 text-sm text-destructive">{error}</div>}
      <p className="text-sm text-muted-foreground">Организация «{tenant?.name}» исчезнет из списка. Доступ её пользователей и терминалов будет отключён, данные осмотров сохранятся.</p>
    </Modal>
  );
};
